import React from 'react'
import { Outlet } from 'react-router-dom'
import { Helmet } from 'react-helmet'

export default function ForgotPasswordLayout() {
    <Helmet>
        <meta charSet="utf-8" />
        <title>Forget Password</title>
    </Helmet>

    return <>
        <Outlet />
    </>
}
